import { FC } from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

interface Props {
    className?: string;
    name: string;
}

const FormError: FC<Props> = ({ className, name }) => {
    const classes = classNames('form__error', className);
    const {
        formState: { errors },
    } = useFormContext(); // retrieve all hook methods

    return (
        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => (
                <div className="form__errors">
                    <div className={classes}>{message}</div>
                </div>
            )}
        />
    );
};

export default FormError;
